import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";

/**
 * Marks a listing that is still being filled, and says why it cannot be opened
 * yet. The row around it is `pointer-events-none` for as long as that lasts, so
 * pointer events are re-enabled here for the tooltip alone — and kept from
 * reaching the link the row is made of.
 */
export default function ListingPopulatingBadge({
  className,
}: {
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="pointer-events-auto cursor-default"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <Loader2Icon
            className={cn(
              "w-4 h-4 animate-spin text-muted-foreground",
              className,
            )}
            aria-label={t("listing.page.list.badges.populating")}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        {t("listing.page.list.badges.populatingTooltip")}
      </TooltipContent>
    </Tooltip>
  );
}
